import axiosInstance from "../../axios/axiosInstance";

export const getAllUsers = (props) => onResponse => {

    try {
        axiosInstance.post("/user/get-users", props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const createUser = (props) => onResponse => {

    try {
        axiosInstance.post("/roles/add-user-with-permission", props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const getSingleUserDetails = (props) => onResponse => {

    try {
        axiosInstance.post("/user/get-user-detail", props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
export const updateUserDetails = (props) => onResponse => {

    try {
        axiosInstance.post("/user/update-user-detail", props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};